<div
  class="bg-white rounded-xl w-full max-w-[1280px] shadow-2xl animate-scale-in max-h-[95vh] sm:max-h-[90vh] overflow-y-auto flex flex-col">
  <!-- Header -->
  <div class="flex items-center justify-between p-[16px] sm:p-[24px] border-b border-gray-300">
    <div class="flex items-center gap-[12px]">
      <div class="w-[40px] h-[40px] bg-primary/10 rounded-lg flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-users w-[20px] h-[20px] text-primary">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      </div>
      <div>
        <h2 class="text-[20px] font-semibold text-foreground flex items-center justify-center mb-0">
          {{ "company.invite.title" | translate }}
        </h2>
      </div>
    </div>
    <button (click)="onCancel()"
      class="inline-flex items-center justify-center gap-[8px] whitespace-nowrap text-[14px] font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-[2px] focus-visible:ring-ring focus-visible:ring-offset-[2px] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-[16px] [&_svg]:shrink-0 hover:text-accent-foreground h-[40px] w-[40px] hover:bg-muted rounded-lg">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="lucide lucide-x w-[20px] h-[20px]">
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
      </svg>
    </button>
  </div>

  <!-- Body -->
  <div class="flex-1 overflow-y-auto p-4 sm:p-6 bg-gradient-to-b from-white via-white to-gray-50">
    <form [formGroup]="inviteForm" (ngSubmit)="onSubmit()" class="flex flex-col h-full">
      <div class="flex-1 space-y-8 pb-4">
        <!-- Info Banner -->
        <div
          class="relative overflow-hidden bg-gradient-to-br from-primary/10 via-primary/5 to-transparent rounded-2xl border-[1px] border-[#e5e7eb] p-6 transition-all duration-300">
          <div class="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-3xl -mr-16 -mt-16"></div>
          <div class="relative flex items-center gap-4">
            <div
              class="w-12 h-12 rounded-xl bg-gradient-to-br from-primary to-primary/80 flex items-center justify-center border border-gray-300 flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                class="w-6 h-6 text-primary-foreground">
                <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
              </svg>
            </div>
            <p class="text-foreground/90 leading-relaxed p-0 m-0">
              {{ "company.invite.description" | translate }}
            </p>
          </div>
        </div>

        <div class="space-y-6">
          <div
            class="space-y-6 bg-white rounded-2xl border-[1px] border-[#e5e7eb] transition-all duration-300 p-[20px]">
            <div class="space-y-4">
              <!-- Header -->
              <div class="flex items-center gap-2 pb-3 border-b-[1px] border-[#e5e7eb]">
                <div class="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="w-4 h-4 text-black">
                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                  </svg>
                </div>
                <label class="text-base font-bold text-foreground m-0"> {{ "common.email" | translate }}</label>
              </div>

              <!-- Input Section -->
              <div class="space-y-3">
                <div *ngFor="let emailForm of emailForms; let i = index"
                  class="group flex items-center gap-1 animate-fade-in">
                  <div class="relative flex-1">
                    <!-- Input Container -->
                    <div class="relative">
                      <!-- Email Icon -->
                      <div
                        class="absolute left-4 top-1/2 -translate-y-1/2 text-primary/60 pointer-events-none transition-colors group-focus-within:text-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="w-5 h-5">
                          <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                        </svg>
                      </div>

                      <!-- Email Input -->
                      <input type="email" [placeholder]="'common.email-placeholder' | translate" maxlength="255"
                        class="w-full pl-11 pr-4 py-3.5 bg-white border rounded-xl text-sm outline-none transition-all shadow-sm focus:ring-2 focus:ring-primary/30 focus:border-primary hover:border-primary/50"
                        [ngClass]="{'border-red-500 focus:border-red-500 focus:ring-red-300': emailForm.get('email')?.invalid && emailForm.get('email')?.touched}"
                        [formControl]="emailForm.get('email')" (focus)="emailForm.get('email')?.markAsTouched()"
                        required />
                    </div>

                    <!-- ⚠️ Validation Message -->
                    <div class="text-red-500 text-xs mt-1"
                      *ngIf="emailForm.get('email')?.invalid && emailForm.get('email')?.touched">
                      {{ getErrorMessage(i) }}
                    </div>
                  </div>

                  <!-- Remove Email Field Button -->
                  <i class="w-[40px] h-[40px] flex items-center justify-center cursor-pointer hover:text-red-500 transition-colors"
                    (click)="removeEmailField(i)" *ngIf="emailForms.length > 1">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                      <path d="M3 6h18" />
                      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                      <line x1="10" y1="11" x2="10" y2="17" />
                      <line x1="14" y1="11" x2="14" y2="17" />
                    </svg>
                  </i>
                </div>

                <!-- Add More Button -->
                <button type="button" (click)="addEmailField()"
                  class="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 rounded-[0.375rem] px-3 w-full mt-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="w-4 h-4 mr-2">
                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                  </svg>
                  {{ "company.invite.add_another_email" | translate }}
                </button>
              </div>

            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- job place section start -->
            <div
              class="space-y-4 bg-white rounded-2xl border-[1px] border-[#e5e7eb] transition-all duration-300 p-[20px]">

              <!-- Header -->
              <div class="flex items-center flex-col sm:flex-row justify-between pb-3 border-b-[1px] border-[#e5e7eb]">
                <div class="flex items-center gap-3">
                  <div
                    class="w-10 h-10 rounded-xl bg-gradient-to-br from-primary/20 to-primary/10 flex items-center justify-center shadow-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-black" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path
                        d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                  </div>
                  <div class="flex flex-col">

                    <label class="text-base font-bold text-foreground">
                      {{ "company.invite.accessWorkplaces" | translate }}
                    </label>
                    <div *ngIf="selectedJobPlaceCount > 0" class="text-sm text-gray-500">
                      {{ selectedJobPlaceCount }} {{ "company.invite.selected" | translate }}
                    </div>
                  </div>
                </div>
                @if (groupedJobPlaces?.length > 0) {
                <button type="button"
                  class="inline-flex items-center justify-center gap-2 h-9 rounded-md px-3 text-xs font-semibold text-black hover:text-primary/80"
                  (click)="selectAllJobPlaces()">
                  {{ areAllJobPlacesSelected()
                  ? ('company.invite.deSelectAll' | translate)
                  : ('company.invite.selectAll' | translate) }}
                </button>
                }

              </div>

              <!-- List -->
              <div class="flex flex-col gap-4 overflow-y-auto max-h-[200px]">
                @if (groupedJobPlaces?.length > 0) {
                @for (group of groupedJobPlaces; track group.stateName) {
                <div>
                  <!-- State Header -->
                  <div
                    class="bg-white border-l-2 border-gray-300 px-3 py-2.5 rounded-lg shadow-md z-10 flex items-center justify-between mb-2">
                    <div
                      class="flex items-center gap-2 bg-gradient-to-r from-primary/10 to-primary/5 -mx-3 -my-2.5 px-3 py-2.5 rounded-lg">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-map-pin w-4 h-4 text-black flex-shrink-0">
                        <path
                          d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
                        </path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                      <span class="font-bold text-sm text-foreground">
                        {{ group.stateName }}
                      </span>
                      <span class="text-xs font-semibold text-primary/70 bg-primary/10 px-2 py-0.5 rounded-full">
                        {{ group.places.length }}
                      </span>
                    </div>
                  </div>

                  <!-- City List -->
                  <div class="grid grid-cols-1 gap-2 pl-2">
                    @for (place of group.places; track place.id) {
                    <div
                      class="flex items-center space-x-3 p-2.5 rounded-lg hover:bg-muted/70 transition-all duration-200 cursor-pointer group gap-1.5">
                      <input type="checkbox" [checked]="jobPlaceIds.includes(place.id)"
                        (change)="toggleJobPlaceSelection(place.id)"
                        class="h-4 w-4 shrink-0 rounded-sm border border-gray-300 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50" />
                      <label (click)="onJobPlaceLabelClick(place.id)"
                        class="text-sm cursor-pointer font-medium group-hover:text-primary transition-colors flex-1 leading-tight m-0">
                        {{ place.name }}
                      </label>
                    </div>
                    }
                  </div>
                </div>
                }
                }
                @else{
                <div
                  class="flex flex-col items-center justify-center text-center py-8 px-4 bg-gray-50 rounded-xl border border-dashed border-gray-300 shadow-sm">
                  <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-50 mb-3">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-black" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path
                        d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                  </div>

                  <h3 class="text-gray-700 font-semibold text-base mb-1">
                    {{ "company.invite.noworkplace-found" | translate }}
                  </h3>
                </div>
                }
              </div>
            </div>
            <!-- Job place section end -->

            <!-- Skills section start -->
            <div class="space-y-4 bg-white rounded-2xl border-[1px] border-[#e5e7eb] transition-all duration-300 p-[20px]">

              <!-- Header -->
              <div class="flex items-center flex-col sm:flex-row justify-between pb-3 border-b border-[#e5e7eb]">
                <div class="flex items-center gap-3">
                  <div
                    class="w-10 h-10 rounded-xl bg-gradient-to-br from-accent/60 to-accent/40 flex items-center justify-center shadow-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-accent-foreground" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                      <rect width="20" height="14" x="2" y="6" rx="2" />
                    </svg>
                  </div>
                  <div class="flex flex-col">
                    <label class="text-base font-bold text-foreground">
                      {{ "company.invite.skillsRoles" | translate }}
                    </label>
                    <div *ngIf="selectedSkillCount > 0" class="text-sm text-gray-500">
                      {{ selectedSkillCount }} {{ "company.invite.selected" | translate }}
                    </div>
                  </div>
                </div>

                <!-- Select / Deselect All Button -->
                <button *ngIf="skills && skills.length > 0" type="button" (click)="toggleSelectAll()"
                  class="inline-flex items-center justify-center gap-2 h-9 rounded-md px-3 text-xs font-semibold text-accent-foreground hover:text-accent-foreground/80">
                  {{ isAllSelected ? ('company.invite.deSelectAll' | translate) : ('company.invite.selectAll' |
                  translate) }}
                </button>
              </div>

              <!-- Skill List -->
              <div *ngIf="skills && skills.length > 0; else noSkillsBlock" class="grid grid-cols-1 gap-2 pl-2">
                @for (skill of skills; track skill.id) {
                <div
                  class="flex items-center space-x-3 p-2.5 rounded-lg hover:bg-muted/70 transition-all duration-200 cursor-pointer group gap-1.5">
                  <input type="checkbox" [checked]="selectedSkillIds.includes(skill.id)"
                    (change)="onSkillChange(skill.id, $event)"
                    class="peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 cursor-pointer checked:bg-primary checked:border-primary" />
                  <label (click)="onSkillLabelClick(skill.id)"
                    class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm cursor-pointer font-medium group-hover:text-primary transition-colors flex-1 leading-tight m-0">
                    {{ skill | skillDisplayName }}
                  </label>
                </div>
                }
              </div>

              <!-- Empty State -->
              <ng-template #noSkillsBlock>
                <div
                  class="flex flex-col items-center justify-center text-center py-8 px-4 bg-gray-50 rounded-xl border border-dashed border-gray-300 shadow-sm">
                  <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-50 mb-3">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-accent-foreground" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                      <rect width="20" height="14" x="2" y="6" rx="2" />
                    </svg>
                  </div>

                  <h3 class="text-gray-700 font-semibold text-base mb-1">
                    {{ "company.invite.noskills-found" | translate }}
                  </h3>
                </div>
              </ng-template>
            </div>
            <!-- Skill section end -->
          </div>
        </div>
        <div
          class="relative overflow-hidden bg-gradient-to-br from-primary/10 via-background to-primary/15 rounded-[24px] border-[1px] border-gray-300 shadow-lg hover:shadow-2xl transition-all duration-[300ms] group md:col-span-2">
          <div
            class="absolute inset-0 bg-gradient-to-r from-transparent via-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-[500ms]">
          </div>
        </div>
      </div>
      <div
        class="relative overflow-hidden bg-gradient-to-br from-primary/10 via-background to-primary/15 rounded-2xl border-[1px] border-[#e5e7eb] transition-all duration-300 group md:col-span-2">
        <div
          class="absolute inset-0 bg-gradient-to-r from-transparent via-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
        </div>

        <div class="relative flex flex-col sm:flex-row items-center justify-between p-[24px]">
          <div class="flex items-center gap-4">
            <div
              class="relative w-14 h-14 shrink-0 rounded-2xl bg-gradient-to-br from-primary to-primary/80 flex items-center justify-center border border-gray-300">
              <div class="absolute inset-0 bg-primary/30 rounded-2xl blur-lg"></div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                class="relative w-7 h-7 text-primary-foreground">
                <path
                  d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0">
                </path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </div>

            <div class="space-y-1.5">
              <label class="text-base font-bold text-foreground block tracking-wide">
                {{ "company.invite.bookingPricingRights" | translate }}
              </label>

              <div class="text-xs text-muted-foreground leading-relaxed space-y-2">
                <p>
                  <span class="font-semibold text-black">{{ "company.invite.on" | translate }}:</span>
                  {{ "company.invite.onDescription" | translate }}
                </p>
                <p>
                  <span class="font-semibold text-muted-foreground">{{ "company.invite.off" | translate }}:</span>
                  {{ "company.invite.offDescription" | translate }}
                </p>
              </div>
            </div>
          </div>
          <div class="flex items-center justify-start w-full sm:w-auto sm:justify-end">
            <span class="text-xs text-black mr-2">
              {{ inviteForm.get('employeeRoleId')?.value === 1
              ? ('company.invite.on' | translate)
              : ('company.invite.off' | translate) }}
            </span>
            <label class="flex items-center m-0 cursor-pointer relative">
              <input type="checkbox" class="sr-only peer" [checked]="inviteForm.get('employeeRoleId')?.value === 1"
                (change)="onToggleChange($event)" />
              <!-- Track -->
              <div class="w-10 h-6 rounded-full bg-gray-300 transition-colors duration-300
             peer-checked:bg-blue-600
             relative">
              </div>
            </label>
          </div>
        </div>
      </div>
      <!-- Footer Buttons -->
      <div
        class="!border-b !border-gray-200 !border-opacity-50 bg-gradient-to-b from-white to-muted/40 p-[16px] sm:p-[24px] mt-4">
        <div class="flex flex-col sm:flex-row gap-[12px] sm:gap-[16px] rounded-[0.75rem]">
          <button type="button" (click)="onCancel()"
            class="inline-flex items-center justify-center gap-[8px] whitespace-nowrap text-[14px] ring-offset-background focus-visible:outline-none focus-visible:ring-[2px] focus-visible:ring-ring focus-visible:ring-offset-[2px] disabled:pointer-events-none disabled:opacity-50 bg-white text-black h-[40px] px-[16px] flex-1 w-full transition-all rounded-[0.75rem] py-[24px] font-semibold disabled:text-gray-300 border border-gray-300 rounded-sm">
            {{ "guard-shift-details.common.cancel" | translate }}
          </button>
          <button type="submit" (click)="onSubmit()" [disabled]="!isFormValid()"
            [ngClass]="{ disabled: !isFormValid() }"
            class="inline-flex items-center justify-center gap-[8px] whitespace-nowrap text-[14px] ring-offset-background focus-visible:outline-none focus-visible:ring-[2px] focus-visible:ring-ring focus-visible:ring-offset-[2px] disabled:pointer-events-none disabled:opacity-50 bg-white text-black h-[40px] px-[16px] flex-1 w-full transition-all rounded-[0.75rem] py-[24px] font-semibold disabled:text-gray-300 border border-gray-300 rounded-sm">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-send w-[20px] h-[20px] mr-[8px]">
              <path
                d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z">
              </path>
              <path d="m21.854 2.147-10.94 10.939"></path>
            </svg>
            {{ "company.invite.send_invites" | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>